/*
 * Copyright (c) 2024 Helvia Technologies PC <contact@helvia.io>
 */

import { RedirectRequestHandler } from '@openid/appauth';

/**
 * Completes the authorization request if necessary & when possible.
 *
 * The reason of sub-classing the RedirectRequestHandler is to always know when the authorization
 * request is completed, no matter if it was successful or not.
 *
 * @see https://github.com/openid/AppAuth-JS/blob/master/src/redirect_based_handler.ts
 */
export class CustomRedirectRequestHandler extends RedirectRequestHandler {
  completeAuthorizationRequestIfPossible() {
    return this.completeAuthorizationRequest().then(result => {
      if (result && this.notifier) {
        this.notifier.onAuthorizationComplete(result.request, result.response, result.error);
      }
      return result;
    });
  }
}
